import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";

import { useChangePlanManager } from "./hooks";
import {
  Breadcrumb,
  Modal,
  NavigateButton,
  SelectSubscriptionStep,
  SuccessStep,
  SummaryStep,
} from "./components";

function ChangePlanModal({ coupon, onClose }) {
  const { activeStepIndex, steps, activeStep, next, back, close } =
    useChangePlanManager(coupon, onClose);
  const scheduleCallLink = useFeatures(
    "insights-upgrade-plan.scheduleCallLink"
  );

  return (
    <Modal size="large" isModalOpen data-test="change-plan-modal">
      <Modal.Header onClose={close}>Plan Update</Modal.Header>
      <Modal.Body scrolling>
        <Breadcrumb activeStepIndex={activeStepIndex} steps={steps} />
        {activeStepIndex === 0 && (
          <SelectSubscriptionStep {...activeStep.props} />
        )}
        {activeStepIndex === 1 && <SummaryStep {...activeStep.props} />}
        {activeStepIndex === 2 && <SuccessStep {...activeStep.props} />}
      </Modal.Body>
      <Modal.Footer>
        <div
          style={{
            display: activeStep.renderLeftActions ? "flex" : undefined,
            justifyContent: "space-between",
          }}
        >
          {activeStep.renderLeftActions && (
            <div style={{ display: "flex" }}>
              <Button
                content="Back"
                onClick={back}
                disabled={activeStep.disableButton}
              />
              {scheduleCallLink && (
                <NavigateButton
                  positive
                  icon="call"
                  content="Schedule a Call"
                  link={scheduleCallLink}
                />
              )}
            </div>
          )}
          <div>
            {activeStep.renderCancelButton && (
              <Button content="Cancel" onClick={close} />
            )}
            <Button
              content={activeStep.actionText}
              primary
              onClick={next}
              loading={activeStep.loadingButton}
              disabled={
                activeStep.disableButton || Boolean(activeStep?.props?.error)
              }
            />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

ChangePlanModal.propTypes = {
  coupon: PropTypes.string,
  onClose: PropTypes.func,
};
ChangePlanModal.defaultProps = { coupon: undefined, onClose: () => {} };

export default ChangePlanModal;
